import { useEffect, useState } from 'react'
import { useWallet } from '@binance-chain/bsc-use-wallet'

import { farmsConfig } from 'config/constants'
import multicall from 'utils/multicall'
import { getMasterChefAddress } from 'utils/addressHelpers'
import masterChefABI from 'config/abi/DungeonMaster.json'
import BigNumber from 'bignumber.js'

import { QuoteToken } from 'config/constants/types'
import fetchFarms from '../state/farms/fetchFarms'
import {fetchFarmUserStakedBalances} from '../state/farms/fetchFarmUser'

import useRefresh from './useRefresh'

const CHAIN_ID = process.env.REACT_APP_CHAIN_ID
const ZERO = new BigNumber(0)

const useAllStaked = (bnbPrice:number,DNDPrice:number) => {
  const [balances, setBalance] = useState([])
  const { account }: { account: string } = useWallet()
  const { fastRefresh } = useRefresh()

  
  useEffect(() => {

    const fetchAllBalances = async () => {
		
		const farms = await fetchFarms();
		const users = await fetchFarmUserStakedBalances(account)

		const nums=[];
		farms.map((farm, index) => {
			let stakedValue:BigNumber=new BigNumber(0);
			const a=new BigNumber(users[index]);
			if(a.isGreaterThan(ZERO)){
				const b=new BigNumber(farm.lpTotal);
				const c=new BigNumber(farm.lpTotalInQuoteToken);
				  stakedValue=a.div(b).multipliedBy(c);
				  
				  
					if(farm.quoteToken.symbol === QuoteToken.BNB){
						stakedValue=stakedValue.multipliedBy(bnbPrice);
					}else if(farm.quoteToken.symbol === QuoteToken.DND){
						stakedValue=stakedValue.multipliedBy(DNDPrice);
					}
					

				  nums.push(stakedValue)
			}
			return stakedValue
		  })
		setBalance(nums);
    }

    if (account) {
      fetchAllBalances()
    }
  }, [account, fastRefresh,bnbPrice,DNDPrice])

  return balances
}

export default useAllStaked
